// src/axiosConfig.js
import axios from 'axios';
import apiConfig from './pages/credentials/apiConfig';

const axiosInstance = axios.create({
  baseURL: apiConfig.apiBaseURL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': apiConfig['x-api-key']
  }
});

// Add JWT to every request
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Handle auth failures globally
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      const status = error.response.status;
      const isUserBlocked = error.response.data?.code === 'USER_BLOCKED' ||
                            error.response.data?.message?.includes('blocked');

      if (status === 401 || status === 403) {
        localStorage.clear();
        const redirectUrl = isUserBlocked ? '/?blocked=true' : '/';
        window.location.href = redirectUrl;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
